// extracted by mini-css-extract-plugin
export default {"icon":"vo_ffK34GCq8el1TCkmPo","labelContainer":"_16wORDpAPZ0_YfM_10Qk1b","container":"rjtNBWkdm1A5sLT93AZ0x"};